<template lang="pug">
  v-badge(
    overlap
    :value="content>0"
    :content="content"
    color="red"
  )
    v-btn(
      color="var(--btn-buy-ticket-powerball-v2)"
      @click="$emit('click')"
    ).cardPowerBall
      slot
        v-row(justify="center" align="center")
          v-img(:src="src" v-if="src").imgCardPowerBall
          h5.white--text.font-weight-power-ball.ml-1 BUY TICKET
</template>
<script>
export default {
  props: {
    content: {
      type: [Number,String],
      default: null
    }
  },
  computed: {
    src: () => require('@/assets/powerball/cart.svg'),
  } 
}
</script>
<style scoped>
@media only screen and (max-width: 960px) { 
  .imgCardPowerBall {
    max-width: 20px !important;
  }
}
.imgCardPowerBall {
  max-width: 30px;
}
.cardPowerBall {
  min-width: min(50vw, 240px) !important;
  border-radius: 12px !important;  
  padding:  min(3vw, 25px) !important;
  /* background-image: linear-gradient(180deg, var(--card-power-ball-v2), var(--card-power-ball-2-v2)); */
} 
</style>